import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/cache';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Apollo Angular configuration — the GraphQL client wired to the
 * Express `/api/graphql` endpoint (see `backend/routes/graphql.js`).
 *
 * Per principle 5 of `docs/BACKEND_ARCHITECTURE.md`:
 * "REST + Prisma is the data-layer default; GraphQL where multi-client
 * or aggregation pays for itself." This client is reserved for screens
 * that aggregate multiple resources (e.g. a dashboard that needs
 * services + packages + cart in one round-trip).
 *
 * Wired via `provideApollo(...)` in `src/main.ts`. Components that
 * need GraphQL `inject(Apollo)` and call `.query(...)` / `.mutate(...)`.
 */
export function apolloConfigFactory() {
  const httpLink = inject(HttpLink);
  return {
    link: httpLink.create({ uri: `${environment.apiUrl}/graphql` }),
    cache: new InMemoryCache(),
    // Keep the cache in normal (non-reset) mode so authenticated
    // routes don't lose data on navigation.
    defaultOptions: {
      watchQuery: { fetchPolicy: 'cache-and-network' as const },
    },
  };
}

export const apolloProvider = provideApollo(apolloConfigFactory);
